import { render, staticRenderFns } from "./From.vue?vue&type=template&id=1d92832e&scoped=true&"
import script from "./From.vue?vue&type=script&lang=js&"
export * from "./From.vue?vue&type=script&lang=js&"
import style0 from "./From.vue?vue&type=style&index=0&id=1d92832e&scoped=true&lang=scss&ref=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d92832e",
  null
  
)

export default component.exports